export interface QuotaOption {
  quota: string
  quotaId: number
  disable: boolean
}

export const msQuota: QuotaOption[] = [
  { quota: '32M', quotaId: 0, disable: false },
  { quota: '64M', quotaId: 1, disable: false },
  { quota: '128M', quotaId: 2, disable: false },
  { quota: '256M', quotaId: 3, disable: false },
  { quota: '512M', quotaId: 4, disable: false },
  { quota: '1G', quotaId: 5, disable: false },
  { quota: '2G', quotaId: 6, disable: false },
  { quota: '3G', quotaId: 7, disable: false },
  { quota: '4G', quotaId: 8, disable: false },
  { quota: '5G', quotaId: 9, disable: false },
  { quota: '6G', quotaId: 10, disable: false },
  { quota: '7G', quotaId: 11, disable: false },
  { quota: '8G', quotaId: 12, disable: false },
  { quota: '10G', quotaId: 13, disable: false },
  { quota: '12G', quotaId: 14, disable: false },
  { quota: '14G', quotaId: 15, disable: false },
  { quota: '16G', quotaId: 16, disable: false },
  { quota: '18G', quotaId: 21, disable: true },
  { quota: '20G', quotaId: 18, disable: true },
  { quota: '24G', quotaId: 19, disable: true },
  { quota: '28G', quotaId: 20, disable: true },
  { quota: '32G', quotaId: 17, disable: true }
]

export const clusterQuota: QuotaOption[] = [
  { quota: '3G', quotaId: 40, disable: false },
  { quota: '6G', quotaId: 38, disable: false },
  { quota: '8G', quotaId: 37, disable: false },
  { quota: '16G', quotaId: 30, disable: false },
  { quota: '20G', quotaId: 32, disable: false },
  { quota: '24G', quotaId: 31, disable: false },
  { quota: '32G', quotaId: 1, disable: false },
  { quota: '40G', quotaId: 2, disable: false },
  { quota: '48G', quotaId: 3, disable: false },
  { quota: '56G', quotaId: 4, disable: false },
  { quota: '64G', quotaId: 5, disable: false },
  { quota: '72G', quotaId: 6, disable: false },
  { quota: '80G', quotaId: 7, disable: false },
  { quota: '88G', quotaId: 8, disable: false },
  { quota: '96G', quotaId: 9, disable: false },
  { quota: '104G', quotaId: 10, disable: false },
  { quota: '112G', quotaId: 11, disable: false },
  { quota: '120G', quotaId: 12, disable: false },
  { quota: '128G', quotaId: 13, disable: false },
  { quota: '136G', quotaId: 14, disable: false },
  { quota: '144G', quotaId: 15, disable: false },
  { quota: '152G', quotaId: 16, disable: false },
  { quota: '160G', quotaId: 17, disable: false },
  { quota: '168G', quotaId: 18, disable: false },
  { quota: '176G', quotaId: 19, disable: false },
  { quota: '184G', quotaId: 20, disable: false },
  { quota: '192G', quotaId: 21, disable: false },
  { quota: '200G', quotaId: 22, disable: false },
  { quota: '208G', quotaId: 23, disable: false },
  { quota: '216G', quotaId: 24, disable: false },
  { quota: '224G', quotaId: 25, disable: false },
  { quota: '232G', quotaId: 26, disable: false },
  { quota: '240G', quotaId: 27, disable: false },
  { quota: '248G', quotaId: 28, disable: false },
  { quota: '256G', quotaId: 29, disable: false },
  { quota: '296G', quotaId: 33, disable: false },
  { quota: '360G', quotaId: 34, disable: false },
  { quota: '400G', quotaId: 35, disable: false },
  { quota: '480G', quotaId: 41, disable: false },
  { quota: '512G', quotaId: 36, disable: false },
  { quota: '576G', quotaId: 42, disable: false },
  { quota: '640G', quotaId: 43, disable: false },
  { quota: '720G', quotaId: 44, disable: false },
  { quota: '768G', quotaId: 39, disable: false }
]

export const pikaQuota: QuotaOption[] = [
  { quota: '512G', quotaId: 0, disable: false },
  { quota: '550G', quotaId: 1, disable: false },
  { quota: '600G', quotaId: 2, disable: false },
  { quota: '650G', quotaId: 3, disable: false },
  { quota: '700G', quotaId: 4, disable: false },
  { quota: '750G', quotaId: 5, disable: false },
  { quota: '800G', quotaId: 6, disable: false },
  { quota: '850G', quotaId: 7, disable: false },
  { quota: '900G', quotaId: 8, disable: false },
  { quota: '950G', quotaId: 9, disable: false },
  { quota: '1T', quotaId: 10, disable: false },
  { quota: '3T', quotaId: 11, disable: true }
]

export const quotaMap: Record<number, QuotaOption[]> = {
  1: msQuota,
  2: clusterQuota,
  3: pikaQuota
}
